<template>
  <div class="article-detail-container">
    <h4>{{ articleTitle }}</h4>
    <img :src="articleImage" :alt="articleImageAlt" />
    <slot name="description"></slot>
    <slot name="blockquote"></slot>
  </div>
</template>

<script>
export default {
  name: 'article-detail-page',
  props: {
    articleTitle: {
      type: String,
      required: true,
    },
    articleImage: {
      type: String,
      required: true,
    },
    articleImageAlt: {
      type: String,
      default: 'Card image cap',
    },
  },
  mounted() {
    let articleElement = document.getElementsByClassName('article-page-wrapper');
    if (!articleElement && !articleElement[0]) return;
    articleElement[0].style.marginBottom = 0;
  },
};
</script>
